<template>
  <div v-loading="pageLoading" class="Replacement">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="补单">
        <span slot="label" ><i class="el-icon-edit-outline"></i> 经销商录单 </span>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" :stretch="stretchValue">
          <el-tab-pane name="安装">
            <span slot="label"><i class="el-icon-s-cooperation"></i> 安装</span>
            <Product ref="Product" :activable="false" @chooseProductChanged="chooseProductChanged"></Product>
            <el-divider content-position="left">信息填写</el-divider>
            <div class="info-background">
              <el-form class="rule-form" :model="replacementIncident" :rules="rules" ref="ruleForm" label-width="100px"
                      label-position="left" :hide-required-asterisk="true">
                <el-form-item label="经销商编码" prop="customerCode">
                  <el-input v-model="replacementIncident.customerCode"></el-input>
                </el-form-item>
                <el-form-item label="产品颜色" v-if="colorShow" prop="productColor">
                  <el-radio-group v-model="replacementIncident.productColor">
                    <el-radio v-for="item in colorList" :key="item.id" :label="item.value">
                        {{item.value}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="客户姓名" prop="name">
                  <el-input v-model="replacementIncident.name"></el-input>
                </el-form-item>
                <el-form-item label="客户电话" prop="phone">
                  <el-input v-model="replacementIncident.phone"></el-input>
                </el-form-item>
                <el-form-item label="所在地区" prop="province">
                  <el-input v-model="replacementIncident.province" @focus="drawer0 = true" :readonly="true"></el-input>
                  <el-drawer
                      title="省市区选择"
                      v-if="drawer0"
                      :visible.sync="drawer0"
                      :direction="direction0"
                      :with-header="false"
                      :size="size0">
                    <mt-picker :slots="myAddressSlots" valueKey="name" :showToolbar="true" :visibleItemCount	="5" @change="addressChange">
                      <Slot>
                        <div class="address_picker_toolbar">
                          <el-row :gutter="20">
                            <el-col :span="4"><span class="address_picker_confirm" @click="drawer0=false">取消</span></el-col>
                            <el-col :span="16"><div class="grid-content bg-purple">省市区选择</div></el-col>
                            <el-col :span="4"><span class="address_picker_confirm" @click="confirmAddress">确认</span></el-col>
                          </el-row>
                        </div>
                      </Slot>
                    </mt-picker>
    <!--                <v-distpicker type="mobile" @selected="onSelected"></v-distpicker>-->
                  </el-drawer>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请具体到楼号及门牌号"
                      v-model="replacementIncident.address">
                  </el-input>
                </el-form-item>
                <el-form-item label="完工日期" prop="workDate">
                  <el-date-picker
                      v-model="replacementIncident.workDate"
                      align="right"
                      :editable="false"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%;"
                      :picker-options="workDatePicker">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="产品SN码" prop="snCode">
                  <el-input placeholder="产品SN码" v-model="replacementIncident.snCode" class="input-with-select">
                    <el-button slot="append" @click="scanQrcode" icon="el-icon-full-screen"></el-button>
                  </el-input>
                </el-form-item>
              </el-form>
              <div class="upload-tip">请提供：完工照片、SN条码照片</div>
              <el-upload
                  :action="this.$uploadURL"
                  ref="upload"
                  :with-credentials="false"
                  :multiple="true"
                  list-type="picture-card"
                  :on-error="uploadError"
                  :on-success="handleAvatarSuccess">
                <i slot="default" class="el-icon-plus"></i>
    <!--            <div slot="file" slot-scope="{file}" @click="clickIn" v-clickout="clickOut">-->
                <div slot="file" slot-scope="{file}">
                  <el-progress v-show="file.percentage!=100" type="circle" :percentage="showfilepercentage(file.percentage)"></el-progress>
                  <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-divider class="info-divider"></el-divider>
              <el-button class="savebtn" type="primary" @click="subbmit('ruleForm')">提交</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane name="维修">
            <span slot="label"><i class="el-icon-s-tools"></i> 维修</span>
            <Product ref="Product" :activable="false" @chooseProductChanged="chooseProductChanged"></Product>
            <el-divider content-position="left">信息填写</el-divider>
            <div class="info-background">
              <el-form class="rule-form" :model="replacementIncident" :rules="rules" ref="ruleForm" label-width="100px"
                      label-position="left" :hide-required-asterisk="true">
                <el-form-item label="经销商编码" prop="customerCode">
                  <el-input v-model="replacementIncident.customerCode"></el-input>
                </el-form-item>
                <el-form-item label="产品颜色" v-if="colorShow" prop="productColor">
                  <el-radio-group v-model="replacementIncident.productColor">
                    <el-radio v-for="item in colorList" :key="item.id" :label="item.value">
                        {{item.value}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="客户姓名" prop="name">
                  <el-input v-model="replacementIncident.name"></el-input>
                </el-form-item>
                <el-form-item label="客户电话" prop="phone">
                  <el-input v-model="replacementIncident.phone"></el-input>
                </el-form-item>
                <el-form-item label="所在地区" prop="province">
                  <el-input v-model="replacementIncident.province" @focus="drawer = true" :readonly="true"></el-input>
                  <el-drawer
                      title="省市区选择"
                      v-if="drawer"
                      :visible.sync="drawer"
                      :direction="direction"
                      :with-header="false"
                      :size="size">
                    <mt-picker :slots="myAddressSlots" valueKey="name" :showToolbar="true" :visibleItemCount	="5" @change="addressChange">
                      <Slot>
                        <div class="address_picker_toolbar">
                          <el-row :gutter="20">
                            <el-col :span="4"><span class="address_picker_confirm" @click="drawer=false">取消</span></el-col>
                            <el-col :span="16"><div class="grid-content bg-purple">省市区选择</div></el-col>
                            <el-col :span="4"><span class="address_picker_confirm" @click="confirmAddress">确认</span></el-col>
                          </el-row>
                        </div>
                      </Slot>
                    </mt-picker>
    <!--                <v-distpicker type="mobile" @selected="onSelected"></v-distpicker>-->
                  </el-drawer>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请具体到楼号及门牌号"
                      v-model="replacementIncident.address">
                  </el-input>
                </el-form-item>
                <el-form-item label="完工日期" prop="workDate">
                  <el-date-picker
                      v-model="replacementIncident.workDate"
                      align="right"
                      :editable="false"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%;"
                      :picker-options="workDatePicker">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="旧机SN码" prop="snCode">
                  <el-input placeholder="旧机SN码" v-model="replacementIncident.snCode" class="input-with-select">
                    <el-button slot="append" @click="scanQrcode" icon="el-icon-full-screen"></el-button>
                  </el-input>
                </el-form-item>
                <!-- <el-form-item label="一位开关（单火）"  label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount" @change="handleChange" :min="0" :max="100" label="一位开关（单火）" />
                </el-form-item>
                <el-form-item label="两位开关（单火）" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount1" @change="handleChange" :min="0" :max="100" label="两位开关（单火）" />
                </el-form-item>
                <el-form-item label="三位开关（单火）" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount2" @change="handleChange" :min="0" :max="100" label="三位开关（单火）" />
                </el-form-item>
                <el-form-item label="一位无线开关" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount3" @change="handleChange" :min="0" :max="100" label="一位无线开关" />
                </el-form-item>
                <el-form-item label="三位情景开关" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount4" @change="handleChange" :min="0" :max="100" label="三位情景开关（无线）" />
                </el-form-item>
                <el-form-item label="三位全屋开关" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount5" @change="handleChange" :min="0" :max="100" label="三位全屋开关（无线）" />
                </el-form-item>
                <el-form-item label="二三级插座" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount6" @change="handleChange" :min="0" :max="100" label="二三级插座" />
                </el-form-item>
                <el-form-item label="一位三级插座16A" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount7" @change="handleChange" :min="0" :max="100" label="一位三级插座（16A）" />
                </el-form-item>
                <el-form-item label="网关插座" label-width="125px" prop="productCount" v-if="'智能开关' == product.series">
                  <el-input-number v-model="switchCount8" @change="handleChange" :min="0" :max="100" label="网关插座" />
                </el-form-item>
                <el-form-item label="数量" label-width="125px" prop="productCount" v-if="'智能开关' != product.series">
                  <el-input-number v-model="replacementIncident.productCount" :min="0" :max="10" label="数量" />
                </el-form-item> -->
                <el-form-item label="故障类别" prop="failureType">
                  <el-input  v-model="replacementIncident.failureType" placeholder="请选择" style="width: 100%" @focus="drawer1 = true"  :readonly="true"></el-input>
                  <el-drawer
                      title="故障类别选择"
                      v-if="drawer1"
                      :visible.sync="drawer1"
                      :direction="direction1"
                      :size="size1">
                    <el-radio :label="f" v-model="replacementIncident.failureType" v-for="(f,i) in failureList" :key="i" class="fail-radio">{{f}}</el-radio>
                  </el-drawer>
                </el-form-item>
                <el-form-item label="维修举措" prop="failureDesc">
                  <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请描述维修举措,如具体故障现象以及使用的配件"
                      v-model="replacementIncident.failureDesc">
                  </el-input>
                </el-form-item>
              </el-form>
              <div class="upload-tip">请提供：更换旧机照片、维修配件照片</div>
              <el-upload
                  :action="this.$uploadURL"
                  ref="upload"
                  :with-credentials="false"
                  :multiple="true"
                  list-type="picture-card"
                  :on-error="uploadError"
                  :on-success="handleAvatarSuccess">
                <i slot="default" class="el-icon-plus"></i>
    <!--            <div slot="file" slot-scope="{file}" @click="clickIn" v-clickout="clickOut">-->
                <div slot="file" slot-scope="{file}">
                  <el-progress v-show="file.percentage!=100" type="circle" :percentage="showfilepercentage(file.percentage)"></el-progress>
                  <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-divider class="info-divider"></el-divider>
              <el-button class="savebtn" type="primary" @click="subbmit('ruleForm')">提交</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    import Product from "../components/ProductReplace"
    // import levelAddress from '@/assets/leveladdress.json'
    import cityData from '@/assets/city-data.js'
    import wx from "weixin-js-sdk";

    export default {
        name: "Replacement",
        components: {
            Product
        },
        data() {
          var checkPhone = (rule, value, callback) => {
              if (!value) {
                  return callback(new Error('手机号不能为空'));
              } else {
                  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                  const reg2 = /0\d{2,3}-\d{7,8}/;
                  const reg3 = /^0\d{9,11}$/;
                  // console.log(reg.test(value));
                  // console.log(reg2.test(value));
                  // console.log(reg3.test(value));
                  if (reg.test(value) || reg2.test(value) || reg3.test(value)) {
                      callback();
                  } else {
                      return callback(new Error('请输入正确的电话'));
                  }
              }
          };
          return {
            activeName: '安装',
            stretchValue: true,
            channels: ['智能门锁','晾衣机','智能窗帘','浴霸/凉霸','风扇灯','吸顶灯','吊灯'],
            switchCount: 0,
            switchCount1: 0,
            switchCount2: 0,
            switchCount3: 0,
            switchCount4: 0,
            switchCount5: 0,
            switchCount6: 0,
            switchCount7: 0,
            switchCount8: 0,
            contact: {},
            product: {},
            pageLoading: false,  // 页面加载遮罩
            workDatePicker: {
                disabledDate: (time) => {
                    // 设置可选择的日期为今天之前
                    const curDate = (new Date()).getTime()
                    const day = 1 * 24 * 3600 * 1000
                    const dateRegion = curDate + day
                    return time.getTime() > dateRegion - 8.64e7
                }
            },
            rules: {
                name: [
                    {required: true, message: '请输入姓名', trigger: 'blur'},
                    {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur'}
                ],
                phone: [
                    {required: true, message: '请输入联系电话', trigger: 'blur'},
                    { validator: checkPhone, trigger: 'blur'}
                ],
                province: [
                    {required: true, message: '请选择所在地区'}
                ],
                address: [
                    {required: true, message: '请输入详细地址', trigger: 'blur'}
                ],
                workDate: [
                    {type: 'string', required: true, message: '请选择完工日期', trigger: 'change'}
                ],
                snCode: [
                    {required: false, message: '请输入S/N编码', trigger: 'blur'}
                ],
                customerCode: [
                    {required: true, message: '请输入经销商编码', trigger: 'blur'}
                ],
                productCount: [
                    {required: false, message: '请输入数量', trigger: 'blur'}
                ],
                productColor: [
                    { required: false, message: '请选择产品颜色', trigger: 'change' }
                ],
                failureType: [
                    { required: false, message: '请选择故障类别', trigger: 'change' }
                ],
                failureDesc: [
                    { required: false, message: '请填写故障描述以及使用配件', trigger: 'blur' }
                ]
            },

            drawer0: false,
            direction0: 'btt',
            size0: '40%',

            drawer: false,
            direction: 'btt',
            size: '40%',

            drawer1: false,
            direction1: 'btt',
            size1: '50%',

            region:'',//三级地址
            regionInit:false,//禁止地区选择器自动初始化，picker组件会默认进行初始化，导致一进入页面就会默认选中一个初始3级地址
            //picker组件插槽
            myAddressSlots: [
                //省
                {
                    flex: 1,
                    values: this.getProvinceArr(), //省份数组
                    className: 'slot1',
                    textAlign: 'center'
                },
                //分隔符
                {
                    divider: true,
                    content: '',
                    className: 'slot2'
                },
                //市
                {
                    flex: 1,
                    values: this.getCityArr("北京"),
                    className: 'slot3',
                    textAlign: 'center'
                },
                {
                    divider: true,
                    content: '',
                    className: 'slot4'
                },
                //县
                {
                    flex: 1,
                    values: this.getCountyArr("北京","北京"),
                    className: 'slot5',
                    textAlign: 'center'
                }
            ],
            // 补单工单
            replacementIncident: {
              replacementType: '安装', // 补单类型
              productType: '',        // 产品类型
              productSeries: '',      // 产品系列
              productModel: '',       // 产品型号
              productCount: '',       // 产品数量
              productColor: '',
                //窗帘、晾衣机
              reservePower: '',
              haveCeiling: '',
              name: '',     // 客户姓名
              phone: '',    // 客户电话
              province: '', // 客户省市区
              address: '',  // 客户详细地址
              workDate: '', // 安装/维修日期
              snCode: '',   // S/N码
              customerCode: '',  // 经销商编码
              fileUrlList: [],   // 图片
              appid:'',      // 公众号id
              failureType: '',
              failureDesc: ''
            },
            colorShow: false,
            colorList: [
              {id:1,value:'陨石黑'},{id:2,value:'香槟金'}
            ],
            failureList: ['请先选择产品'],
            // 智能门锁
            failureZnms: [
              '密码按键不灵敏', '指纹识别慢', '指纹不能识别','不通电',
              '密码验证开锁失效','指纹验证开锁失效','钥匙开锁失效',
              '锁自动打开','电池耗电快','金属生锈','其他'
            ],
            // 晾衣机
            failureLyj: [
              '灯不亮','升降异常','电机异响',
              '外壳破损','钢绳断','其他'
            ],
            // 智能窗帘
            failureZncl: [
              '电机不转','电机异响','轨道卡滞','其他'
            ],
            // 浴霸
            failureYb: [
              '不换气','灯不亮','不出热风',
              '外壳破损','电机不转','其他'
            ],
            // 凉霸
            failureLb: [
              '不吹风','灯不亮','外壳破损',
              '电机不转','其他'
            ],
            // 风扇灯
            failureFsd: [
              '扇叶晃动','灯不亮','扇叶破损',
              '外壳破损','扇叶不转','其他'
            ],
            // 吸顶灯
            failureXdd: [
              '灯不亮','频闪','外壳破损','其他'
            ],
            // 吊灯
            failureDd: [
              '灯不亮','频闪','外壳破损', '吊杆断裂', '其他'
            ],
            // 智能开关
            failureZnkg: [
               "按键没反应","开关灯闪烁", "无法联网","关灯后灯微亮","APP控制问题","设备经常离线","其他"
            ]
          }
        },
        watch: {
            product: {
                handler(){
                  this.replacementIncident.failureType = '';
                  switch (this.product.type) {
                    case "智能门锁":
                      this.failureList = this.failureZnms;
                      break;
                    case "晾衣机":
                      this.failureList = this.failureLyj;
                      break;
                    case "智能窗帘":
                      this.failureList = this.failureZncl;
                      break;
                    case "吊灯":
                      this.failureList = this.failureDd;
                      break;
                    case "吸顶灯":
                      this.failureList = this.failureXdd;
                      break;
                    case "风扇灯":
                      this.failureList = this.failureFsd;
                      break;
                    case "浴霸":
                      this.failureList = this.failureYb;
                      break;
                    case "凉霸":
                      this.failureList = this.failureLb;
                      break;
                    case "智能开关":
                      this.failureList = this.failureZnkg;
                      break;
                  }
                },
                deep: true
            }
        },
        mounted() {
          
        },
        methods: {
          onSelected(data) {
              this.replacementIncident.province = data.province.value + ' ' + data.city.value + ' ' + data.area.value
              console.log(this.replacementIncident.province)
          },
          handleAvatarSuccess(response){
              this.replacementIncident.fileUrlList.push(response);
          },
          handleRemove(file) {
              this.replacementIncident.fileUrlList.splice(this.replacementIncident.fileUrlList.indexOf(file.response),1);
              this.$refs.upload.handleRemove(file);
          },
          uploadError(error) {
            console.log("error",error);
          },
          showfilepercentage(per){
            return Math.floor(per);
          },
          confirmAddress(){
            //取值并赋值
            this.replacementIncident.province = this.region==''?'北京市 北京市 东城区':this.region;
            console.log(this.replacementIncident.province);
            this.drawer0 = false;
            this.drawer = false;
          },
          //picker组件的change事件，进行取值赋值
          addressChange(picker, values){
            if (this.regionInit){
              this.region = values[0]["name"] + " " + values[1]["name"] + " " + values[2]["name"];
              //给市、县赋值
              picker.setSlotValues(1, this.getCityArr(values[0]["name"]));
              picker.setSlotValues(2, this.getCountyArr(values[0]["name"], values[1]["name"]));
            }else {
                this.regionInit = true;
            }
          },
          //遍历json，返回省级对象数组
          getProvinceArr() {
              let provinceArr = [];
              cityData.forEach(function (item) {
                  let obj = {};
                  obj.name = item.label;
                  provinceArr.push(obj);
              });
              return provinceArr;
          },
          //遍历json，返回市级对象数组
          getCityArr(province) {
              let cityArr = [];
              cityData.forEach(function (item) {
                  if (item.label === province) {
                      item.children.forEach(function (args) {
                          let obj = {};
                          obj.name = args.label;
                          cityArr.push(obj);
                      });
                  }
              });
              return cityArr;
          },
          //遍历json，返回县级对象数组
          getCountyArr(province,city){
              let countyArr = [];
              cityData.forEach(function(item){
                  if (item.label === province){
                      item.children.forEach(function (args) {
                          if (args.label === city){
                              args.children.forEach(function (param) {
                                  let obj = {};
                                  obj.name=param.label;
                                  countyArr.push(obj);
                              })
                          }
                      });
                  }
              });
              return countyArr;
          },
          subbmit(formName) {
            console.log(this.product)
              if(JSON.stringify(this.product)=='{}'){
                this.$message({
                    type: 'warning',
                    message: '请选择产品!',
                    offset: 60
                });
                return
              }
              // if(this.replacementIncident.snCode!=''){
              //     this.replacementIncident.snCode = this.replacementIncident.snCode.replace('SN:', '')
              //      let reg = /^[a-zA-Z]\w{3,15}$/g  //以abc开头，忽略大小写
              //     if (this.product.model === 'X1') {
              //       reg = /^X120[0-9]{9,10}$/g
              //     } else if (this.product.model === 'X3') {
              //       reg = /^X320[0-9]{9,10}$/g
              //     } else if (this.product.model === 'X50') {
              //       reg = /^SAC100X50[0-9A-Z]{8}$/g
              //     } else if (this.product.model === 'X70') {
              //       reg = /^SAC100X70[0-9A-Z]{8}$/g
              //     } else if (this.product.model === 'K73') {
              //       reg = /^SAA100K73[0-9A-Z]{8}$/g
              //     } else if (this.product.model === 'K75') {
              //       reg = /^SAA200K75[0-9A-Z]{8}$/g
              //     } else if (this.product.model === 'GN-1101') {
              //       reg = /^SA[0-9A-Z]{15}$/g
              //     } else if (this.product.model === 'G27') {
              //       reg = /^SA[0-9]{11}$/g
              //     } else if (this.product.model === 'CW11WJW') {
              //       reg = /^SAF102CW1[0-9A-Z]{8}$/g
              //     }
              //     if(!reg.test(this.replacementIncident.snCode)){
              //       this.$message({
              //           type: 'warning',
              //           message: '请正确填写SN码!',
              //           offset: 60
              //       });
              //       return
              //     }
              // }
              // if(this.replacementIncident.fileUrlList.length<2){
              //   if(this.activeName === '安装'){
              //     this.$message({
              //         type: 'warning',
              //         message: '请上传： 完工照片、SN条码照片!(每种至少一张)',
              //         offset: 60
              //     });
              //   } else {
              //     this.$message({
              //         type: 'warning',
              //         message: '请上传： 更换旧机照片、维修配件照片!(每种至少一张)',
              //         offset: 60
              //     });
              //   }
              //   return
              // }
              if(this.activeName === '维修'){
                if(this.replacementIncident.failureType === ''){
                  this.$message({
                      type: 'warning',
                      message: '请选择故障类别',
                      offset: 60
                  });
                  return
                } 
                if(this.replacementIncident.failureDesc === '') {
                  this.$message({
                      type: 'warning',
                      message: '请填写故障描述以及使用配件',
                      offset: 60
                  });
                  return
                }
                if(this.replacementIncident.fileUrlList.length<2){
                  this.$message({
                      type: 'warning',
                      message: '请上传： 更换旧机照片、维修配件照片!(每种至少一张)',
                      offset: 60
                  });
                  return
                }
              }else{
                if(this.replacementIncident.snCode === ''&&
                  (this.product.type==='智能门锁'||this.product.type==='晾衣机'||this.product.type==='智能窗帘')){
                  this.$message({
                      type: 'warning',
                      message: '请填写SN码',
                      offset: 60
                  });
                  return
                }
              }
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      this.pageLoading = true;
                      this.replacementIncident.productType = this.product.type;
                      this.replacementIncident.productCount = '1'
                      this.replacementIncident.productSeries = this.product.type;
                      this.replacementIncident.productModel = this.product.model;
                      // 补单提交
                      this.$axios.post(this.$baseURL + `/incident/replacement`,this.$qs.stringify(this.replacementIncident))
                          .then( res => {
                            this.pageLoading = false;
                            if(res.data==='SN已存在'){
                              this.$message({
                                  type: 'warning',
                                  message: 'SN码已存在!',
                                  offset: 60
                              });
                            }else{
                              console.log("报单成功！");
                              this.$confirm('您已提交成功，我们会尽快处理！', '', {
                                  confirmButtonText: '确定',
                                  showCancelButton: false,
                                  type: 'success',
                                  showClose: false,
                                  closeOnClickModal: false,
                                  customClass: 'message-logout'
                              }).then(() => {
                                  // 提交成功点击确定，刷新页面
                                  console.log("refresh");
                                  this.$router.go(0);
                              }).catch(() => {
                                  // DO NOTHING
                              });
                            }
                          })
                          .catch(error=> {
                              console.log(error.response);
                              console.log(error.response.data.status);
                              if(error.response.data.status == 400){
                                  this.$message({
                                      type: 'warning',
                                      message: '未找到经销商，请输入正确的编码',
                                      offset: 60
                                  });
                              }else {
                                  this.$message({
                                      type: 'warning',
                                      message: '提交失败，请重试或联系客服',
                                      offset: 60
                                  });
                              }
                              this.pageLoading = false;
                          });
                  } else {
                      console.log('error submit!!');
                      console.log(valid);
                      return false;
                  }
              });
          },
          handleChange() {
              let productCount = ''
              if(this.switchCount !== 0) {
                productCount +=  '一位开关（单火）:' + this.switchCount + ';'
              }
              if(this.switchCount1 !== 0) {
                productCount +=  '两位开关（单火）:' + this.switchCount1 + ';'
              }
              if(this.switchCount2 !== 0) {
                productCount +=  '三位开关（单火）:' + this.switchCount2 + ';'
              }
              if(this.switchCount3 !== 0) {
                productCount +=  '一位无线开关:' + this.switchCount3 + ';'
              }
              if(this.switchCount4 !== 0) {
                productCount +=  '三位情景开关（无线）:' + this.switchCount4 + ';'
              }
              if(this.switchCount5 !== 0) {
                productCount +=  '三位全屋开关（无线）:' + this.switchCount5 + ';'
              }
              if(this.switchCount6 !== 0) {
                productCount +=  '二三级插座:' + this.switchCount6 + ';'
              }
              if(this.switchCount7 !== 0) {
                productCount +=  ' 一位三级插座（16A）:' + this.switchCount7 + ';'
              }
              if(this.switchCount8 !== 0) {
                productCount +=  '网关插座 :' + this.switchCount8 + ';'
              }
              if(productCount !== '') {
                this.replacementIncident.productCount = productCount
              } else {
                this.replacementIncident.productCount = '1'
              }
          },
          wechatConfig() {
            let url = encodeURIComponent(window.location.href.split('#')[0])
            this.$axios.get(this.$baseURL + '/incident/getWxConfig?url='+url).then(res=> {
              wx.config({
                debug: false,
                appId: res.data.appid, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名
                jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
              });
              wx.ready(function() {
                wx.checkJsApi({
                    jsApiList: ['scanQRCode'],
                    success: function(res) {
                      console.log(res)
                      if (res.checkResult.scanQRCode == true) {
                          console.log('查询成功')
                      } else {
                          alert('抱歉，当前客户端版本不支持扫一扫,请升级到最新版本');
                      }
                    },
                    fail: function(res) {
                        alert('fail' + res);
                    }
                });
              });
            }).catch(error=> {
                console.log("：报错"+error);
            });
          },
          scanQrcode() {
            let this_ = this;
              wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                  // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                  if (res.resultStr.indexOf('SN:') !== -1) {
                    this_.replacementIncident.snCode = res.resultStr.replace('SN:', '');
                  } else {
                    this_.replacementIncident.snCode = res.resultStr;
                  }
                }
              });
          },
          chooseProductChanged(){
           
          },
          handleClick(tab, event){
            console.log(tab, event);
            this.replacementIncident.replacementType = tab.name
          }
        },
        created() {
            // 公众号appid
            if (typeof this.$route.query.appid === 'undefined') {
                // 选择产品返回后，路由参数不再携带appid，此时主动刷新页面或提交成功后自动刷新页面，都需要从localstorage中获取appid
                this.replacementIncident.appid = window.localStorage.getItem("fastappid");
                if(this.replacementIncident.appid == null){
                    // localstorage中也不存在appid，特殊情况，调用微信sdk关闭页面
                    wx.closeWindow();
                }
            }else {
                // 将url携带的appid存入localstorage
                this.replacementIncident.appid = this.$route.query.appid;
                window.localStorage.setItem("fastappid",this.replacementIncident.appid);
            }
            this.wechatConfig()
        },
        activated() {
            // 在选择产品后，返回页面时触发
            this.product = this.$refs.Product.s_product;
            console.log(this.product)
            // this.replacementIncident.productColor = ''
            // this.colorShow = true
            //更新颜色列表
            // if(this.product.model == 'X1'){
            //   this.colorList =   [{id:1,value:'红古铜'}]
            //   this.replacementIncident.productColor = '红古铜'
            // }else if(this.product.model == 'X3'){
            //   this.colorList =   [{id:1,value:'黑色'}]
            //   this.replacementIncident.productColor = '黑色'
            // }else if(this.product.model == 'X50'){
            //   this.colorList =   [{id:1,value:'红古铜'},{id:1,value:'太空灰'}]
            // }else if(this.product.model == 'K73'){
            //   this.colorList =   [{id:1,value:'陨石黑'},{id:1,value:'太空灰'}]
            // }else if(this.product.model == 'K75'){
            //   this.colorList =   [{id:1,value:'摩卡棕'},{id:1,value:'太空灰'}]
            // }else if(this.product.model == 'GN-1101'){
            //   this.colorList =   [{id:1,value:'香槟金'},{id:1,value:'星空灰'},{id:1,value:'皓月白'}]
            // }else{
            //   this.replacementIncident.productColor = '无'
            //   this.colorShow = false
            // }
        },
    };
</script>

<style scoped>
  .el-radio {
    margin: 10px 30px;
  }

  .rule-form {
    padding: 0px 10px;
    font-size: 13px;
  }

  .savebtn {
    margin-bottom: 20px;
  }
</style>
